import { render } from "./ServiceDetailAiData.vue?vue&type=template&id=45595835"
import script from "./ServiceDetailAiData.vue?vue&type=script&lang=js"
export * from "./ServiceDetailAiData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__